export default __webpack_public_path__ + "static/media/Honorarios_planilla_CUD_de_asistencia.f1fa81fd.xlsx";